import AccountsPage from './AccountsPage';
import PoliciesPage from './PoliciesPage';
import GroupsPage from './GroupsPage';
import SettingsPage from './SettingsPage';
import SessionsPage from './SessionsPage';
import ReportsPage from './ReportsPage';
import { TradeTable } from './TradeTable';
import { useManagerData } from './useManagerData';

export const ParityWorkspace=({page,permissions})=>{
 const allowedMeta=permissions.some(p=>['manager.accounts.view','manager.orders.create','manager.positions.view','manager.transactions.view','manager.reports.view','manager.terms.manage','manager.groups.manage'].includes(p));
 const metadata=useManagerData('/metadata',{},allowedMeta);
 const meta=metadata.data||{clients:[],terms:[],groups:[],instruments:[]};
 const props={permissions,meta,refreshMeta:metadata.reload};
 if(page==='accounts')return <AccountsPage {...props}/>;
 if(page==='trading-terms'||page==='instruments')return <PoliciesPage {...props} mode={page==='instruments'?'instruments':'terms'}/>;
 if(page==='permission-groups')return <GroupsPage {...props}/>;
 if(page==='trading-sessions')return <SessionsPage {...props}/>;
 if(page==='settings')return <SettingsPage {...props}/>;
 if(page==='reports'||page==='journal')return <ReportsPage {...props} journal={page==='journal'}/>;
 const type=page==='pending-orders'?'orders':page==='transactions'?'transactions':'positions';
 const status=page==='open-positions'?'open':page==='closed-positions'?'closed':page==='pending-orders'?'pending':undefined;
 const title={'open-positions':'Açık Pozisyonlar','closed-positions':'Kapalı Pozisyonlar','pending-orders':'Bekleyen Emirler',transactions:'Finansal İşlemler'}[page];
 return <section className="manager-data-page" data-testid={`manager-page-${page}`}><div className="manager-page-toolbar"><div><p className="crm-eyebrow">TRADING MANAGER</p><h1>{title}</h1></div></div><TradeTable type={type} status={status} permissions={permissions} meta={meta}/></section>;
};